<template>
  <VLoader v-if="videosLoading" />
  <div v-else class="w-full h-full">
    <VideoCards :videos="videos" :serie="serie" @delete="handleDelete" @edit="handleEdit" />

    <!-- Modals -->
    <ModalPlus
      title="Add Video"
      buttonText="Add Video"
      :show="showModal"
      :onClose="handleClose"
      :onProceed="handleSubmit(handleAddVideo)"
      :loading="formLoading"
      maxWidth="900px"
    >
      <div class="py-8 pb-4">
        <VideoForm :errors="errors" @set="handleSetField" :showIntro="false" />
      </div>
    </ModalPlus>
  </div>
</template>

<script>
import { formMixin, videosViewMixin } from '@/mixins';

import VLoader from '@/components/base/VLoader';
import ModalPlus from '@/components/shared/modal/ModalPlus';
import VideoCards from '@/components/admin/VideoCards';
import VideoForm from '@/components/admin/VideoForm';

export default {
  name: 'AdminTrainingVideosView',
  components: {
    VLoader,
    VideoCards,
    VideoForm,
    ModalPlus,
  },
  mixins: [
    formMixin({ title: '', summary: '', order: '', embed_code: '', thumbnail: null }, [
      'thumbnail',
    ]),
    videosViewMixin('training-videos'),
  ],
  watch: {
    async language({ code }) {
      this.videos = await this.fetchVideos(this.$http, this.$route.params.id, code);
    },
  },
  methods: {
    async handleAddVideo(data) {
      const serieId = this.$route.params.id;

      const requestData = {
        ...data,
        group_id: serieId,
        lang_code: this.language.code,
      };

      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));

      const res = await this.$http.post(`/admin/training-videos`, formData);
      this.videos = this.videos.concat(res.data.data);

      this.handleResetFields();
      this.handleClose();
    },
  },
};
</script>
